import { Link } from 'react-router-dom';
import { NAV } from '@/constants/testIds';

export const Logo = ({ compact = false }) => {
  return (
    <Link
      to="/"
      data-testid={NAV.logo}
      className="group inline-flex items-center gap-3"
      aria-label="A Guy Who Hunts — Home"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        aria-hidden="true"
        className="text-[hsl(var(--primary))]"
        fill="none"
      >
        <path
          d="M4 25c3-2 5-4 8-4s5 2 8 4c2 1 5 2 8-1"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M11 20l1.5-3M20 20l-1.5-3M14 15l2-3 2 3"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="font-serif font-semibold tracking-tight leading-none text-[hsl(var(--foreground))]">
        <span className={compact ? 'text-lg' : 'text-xl'}>A Guy Who Hunts</span>
      </span>
    </Link>
  );
};
